/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */


const theme = {
  appearances: {
    checked: {
      description: 'Corresponds to a selected state for a checkbox or radio',
      type: 'state',
      values: [ true ]
    },
    error: { type: 'state', values: [ true ] },
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    inactive: {
      description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
      type: 'state',
      values: [ true ]
    },
    pressed: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    },
    viewport: {
      description: 'The size label for the current screen viewport based on the current screen width',
      type: 'state',
      values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
    }
  },
  rules: [
    {
      if: { viewport: [ 'lg', 'xl' ] },
      tokens: {
        fontSize: 24,
        lineHeight: 1.33333333333,
        paddingBottom: 24,
        paddingLeft: 16,
        paddingRight: 24,
        paddingTop: 16
      }
    },
    {
      if: { hover: true },
      tokens: {
        borderColor: '#676e73',
        checkboxOuterBorderColor: '#e3e6e8',
        checkboxOuterBorderWidth: 2,
        outerBorderColor: '#e3e6e8'
      }
    },
    {
      if: { focus: true },
      tokens: {
        checkboxInputBorderColor: '#7c53a5',
        checkboxInputBorderWidth: 3,
        outerBorderColor: '#676e73',
        outerBorderGap: 2
      }
    },
    {
      description: 'Pressed state matches hover state plus light grey background',
      if: { pressed: true },
      tokens: {
        backgroundColor: '#f4f4f7',
        borderColor: '#676e73',
        checkboxInputBorderColor: '#676e73',
        checkboxInputBorderWidth: 1,
        checkboxOuterBorderColor: '#e3e6e8',
        checkboxOuterBorderWidth: 3,
        outerBorderColor: '#e3e6e8',
        outerBorderGap: 0
      }
    },
    { if: { checked: true }, tokens: { borderColor: '#7c53a5' } },
    {
      if: { checked: true, hover: true },
      tokens: { borderColor: '#4b286d' }
    },
    {
      if: { error: true },
      tokens: {
        borderColor: '#e12339',
        checkboxInputBorderColor: '#e12339',
        color: '#e12339'
      }
    },
    {
      if: { inactive: true },
      tokens: {
        backgroundColor: '#f4f4f7',
        borderColor: 'rgba(0, 0, 0, 0)',
        checkboxCheckedBackgroundColor: '#676e73',
        checkboxInputBackgroundColor: '#b2b9bf',
        checkboxInputBorderColor: 'transparent',
        checkboxInputSize: 12,
        checkboxOuterBorderColor: '#b2b9bf',
        checkboxOuterBorderGap: 2,
        checkboxOuterBorderWidth: 1,
        color: '#676e73'
      }
    }
  ],
  tokens: {
    backgroundColor: '#ffffff',
    borderColor: '#b2b9bf',
    borderRadius: 6,
    borderWidth: 1,
    checkboxCheckedBackgroundColor: '#7c53a5',
    checkboxCheckedSize: 12,
    checkboxInputBackgroundColor: '#ffffff',
    checkboxInputBorderColor: '#676e73',
    checkboxInputBorderWidth: 1,
    checkboxInputOutlineColor: 'rgba(0, 0, 0, 0)',
    checkboxInputOutlineWidth: 0,
    checkboxInputSize: 20,
    checkboxOuterBorderColor: 'transparent',
    checkboxOuterBorderGap: 0,
    checkboxOuterBorderWidth: 0,
    checkboxSpace: 2,
    color: '#2c2e30',
    contentAlignItems: 'stretch',
    contentFlexGrow: 0,
    contentFlexShrink: 1,
    contentJustifyContent: 'flex-start',
    contentSpace: 2,
    flex: 1,
    fontName: 'HNforTELUSSA',
    fontSize: 20,
    fontWeight: '500',
    letterSpacing: 0,
    lineHeight: 1.4,
    minWidth: 264,
    outerBorderColor: 'transparent',
    outerBorderGap: 0,
    outerBorderWidth: 2,
    paddingBottom: 16,
    paddingLeft: 10,
    paddingRight: 16,
    paddingTop: 16,
    shadow: null,
    textTransform: 'none'
  }
}
export default theme
